import React from 'react'

function DMCA() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins mt-5 lg:m-[100px]">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">DMCA Notice</h2>
      <div className="space-y-8 max-w-4xl">

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">DMCA Compliance</h3>
            <p className="text-sm text-white mt-4">
              At <span className="text-btn-color font-bold">FinzAid.com</span>, we respect the intellectual property rights of others and expect our users to do the same. In compliance with the **Digital Millennium Copyright Act** (DMCA), we have implemented procedures to ensure that any copyrighted content is appropriately handled.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Filing a DMCA Complaint</h3>
            <p className="text-sm text-white mt-4">
              If you believe that any content on <span className="text-btn-color font-bold">FinzAid.com</span> violates your copyright, you may submit a DMCA takedown request by providing us with the following information:
            </p>
            <ul className="list-disc list-inside text-sm text-gray-300 mt-4">
              <li>A physical or electronic signature of the copyright owner or authorized agent.</li>
              <li>Identification of the copyrighted work claimed to have been infringed.</li>
              <li>Identification of the material that is claimed to be infringing and information reasonably sufficient to permit us to locate the material.</li>
              <li>Contact information, including your address, telephone number, and email address.</li>
              <li>A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner.</li>
              <li>A statement, under penalty of perjury, that the information in your notice is accurate and that you are the copyright owner or authorized to act on the owner's behalf.</li>
            </ul>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Counter-Notification</h3>
            <p className="text-sm text-white mt-4">
              If you believe that the material removed or to which access was disabled is not infringing, or that you have the legal right to post the content, you may send us a counter-notification with the following information:
            </p>
            <ul className="list-disc list-inside text-sm text-gray-300 mt-4">
              <li>Your physical or electronic signature.</li>
              <li>Identification of the material that has been removed or disabled, and the location where it appeared before it was removed or disabled.</li>
              <li>A statement under penalty of perjury that you have a good faith belief that the material was removed or disabled as a result of mistake or misidentification.</li>
              <li>Your name, address, telephone number, and email address, and a statement that you consent to the jurisdiction of the federal court in your district.</li>
            </ul>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Repeat Infringer Policy</h3>
            <p className="text-sm text-white mt-4">
              <span className="text-btn-color font-bold">FinzAid.com</span> reserves the right to terminate user accounts that are repeat infringers of intellectual property laws.
            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default DMCA;
